import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { RightsContext } from 'providers/RightsContext';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import OfferPartnerVerificationSummaryModal from './OfferPartnerVerificationSummaryModal';
import OfferPartnerVerificationItem from './OfferPartnerVerificationItem';

const OfferPartnerVerification = ({ showSensitiveInfoError, downloadFile, data }) => {
  const [verificationSummaryModalOpen, setVerificationSummaryModalOpen] = useState(false);
  const [verificationSummaryModalIndex, setVerificationSummaryModalIndex] = useState(-1);
  const [t] = useTranslation();

  const { clientSensitiveInfoRead } = useContext(RightsContext);

  const toggleVerificationSummaryModal = index => {
    setVerificationSummaryModalOpen(!verificationSummaryModalOpen);
    setVerificationSummaryModalIndex(index);
  };

  const onDownloadClick = (event, item) => {
    if (disableDownload(item)) {
      showSensitiveInfoError();
      return;
    }

    event.preventDefault();
    downloadFile(item.sharepointUniqueId);
  };

  const disableDownload = item => {
    if (item.sensitiveInfo && !clientSensitiveInfoRead) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>{t('OfferEdit.Client.Verification.Type')}</strong>
            </TableCell>
            <TableCell>
              <strong>{t('OfferEdit.Client.Verification.Partner')}</strong>
            </TableCell>
            <TableCell>
              <strong>{t('OfferEdit.Client.Verification.State')}</strong>
            </TableCell>
            <TableCell>
              <strong>{t('OfferEdit.Client.Verification.User')}</strong>
            </TableCell>
            <TableCell>
              <strong>{t('OfferEdit.Client.Verification.Date')}</strong>
            </TableCell>
            <TableCell>
              <strong>{t('OfferEdit.Client.Verification.ValidityDate')}</strong>
            </TableCell>
            <TableCell>
              <strong>{t('OfferEdit.Client.Verification.SummaryTitle')}</strong>
            </TableCell>
            <TableCell>
              <strong>{t('OfferEdit.Client.Verification.Comments')}</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <OfferPartnerVerificationItem
              key={item.verificationId}
              idx={index}
              onDownloadClick={onDownloadClick}
              toggleVerificationSummaryModal={toggleVerificationSummaryModal}
              item={item}
            />
          ))}
        </TableBody>
      </Table>

      {verificationSummaryModalOpen && (
        <OfferPartnerVerificationSummaryModal
          verificationSummaryModalOpen={verificationSummaryModalOpen}
          closeVerificationSummaryModal={toggleVerificationSummaryModal}
          summary={data[verificationSummaryModalIndex]?.summary.replace(/(?:\r\n|\r|\n)/g, '<br>')}
        />
      )}
    </>
  );
};

OfferPartnerVerification.propTypes = {
  data: PropTypes.array.isRequired,
  downloadFile: PropTypes.func.isRequired,
  showSensitiveInfoError: PropTypes.func.isRequired
};

export default OfferPartnerVerification;
